export default __webpack_public_path__ + "static/media/Thorlabs.232a4c2a.png";